import React from "react";
import { SovosPill } from "mosaic-react";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";

const isBlockedValue = (blocked) => blocked === true || blocked === 1 || blocked === "true";

const UserStatus = (props) => {
    const { i18n } = useGlobalValue();
    const { value: cell } = props || {};
    const isBlocked = isBlockedValue(cell?.blocked);
    const labelKey = isBlocked ? "user-status-true" : "user-status-false";

    return (
        <SovosPill color={isBlocked ? "neutral" : "success"}>{i18n`${labelKey}`}</SovosPill>
    );
};

export default UserStatus;
